import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const Partners = (props) => {
  const containerRef = useRef(null);
  const imagesRefs = useRef([]);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size on mount and update isMobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust 768px as per your design
    };

    handleResize(); // Call on mount to check initial screen size
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Continuous scrolling logic for larger screens
  useEffect(() => {
    if (!isMobile) {
      const container = containerRef.current;
      const images = imagesRefs.current;

      const totalWidth = images.reduce((acc, image) => acc + image.offsetWidth, 0);

      images.forEach((image, i) => {
        const clone = image.cloneNode(true);
        container.appendChild(clone);
        imagesRefs.current.push(clone);
      });

      gsap.to(imagesRefs.current, {
        x: `-=${totalWidth}`,
        duration: totalWidth / 10,
        ease: "none",
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize((x) => {
            return parseFloat(x) % totalWidth;
          }),
        },
      });

      return () => {
        gsap.killTweensOf(imagesRefs.current);
      };
    }
  }, [props.data, isMobile]);

  const partnerItemsStyle = {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
  };

  const partnerItemStyle = {
    flex: "0 0 auto",
    marginRight: "20px",
    width: "150px",
  };

  const partnerContainerStyle = {
    position: "relative",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
  };

  // Centered styling for images in the carousel (mobile view)
  const mobileImageStyle = {
    maxWidth: "100%",
    height: "auto",
    marginLeft: "50% ", // Center the image horizontally
    display: "block",
  };

  const mobileCarouselStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const sectionStyle = {
    paddingBottom: "55px",
    paddingTop: '10px',
  }
  const rowStyle = {
    paddingTop: "10px",
  }

  return (
    <div id="partner" style={partnerContainerStyle}>
      <div className="container" style={sectionStyle}>
        <div className="section-title text-center">
          <h2>Our Partners</h2>
          <p>We have a digital Solution to every business problem</p>
        </div>
        <div className="row" style={rowStyle}>
          {!isMobile ? (
            <div className="partner-items" ref={containerRef} style={partnerItemsStyle}>
              {props.data
                ? props.data.map((d, i) => (
                    <div
                      key={`${d.title}-${i}`}
                      className="partner-item"
                      style={partnerItemStyle}
                      ref={(el) => (imagesRefs.current[i] = el)}
                    >
                      <img
                        src={d.smallImage}
                        alt={d.title}
                        className="partner-image"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  ))
                : "Loading..."}
            </div>
          ) : (
            <Carousel
              showThumbs={false}
              showStatus={false}
              infiniteLoop={true}
              autoPlay={true}
              style={mobileCarouselStyle} // Apply centered styling
            >
              {props.data
                ? props.data.map((d, i) => (
                    <div key={`${d.title}-${i}`} className="partner-item">
                      <img
                        src={d.smallImage}
                        alt={d.title}
                        className="partner-image"
                        style={mobileImageStyle} // Apply centered styling to each image
                      />
                    </div>
                  ))
                : "Loading..."}
            </Carousel>
          )}
        </div>
      </div>
    </div>
  );
};
